<!--
  @Description 节假日设置
  @Date 2021-12-22
  @Author liufu
-->
<template>
  <div class="container">
    <homeHeader title="节假日"></homeHeader>
    <div class="main">
      <div class="card">
        <!-- 查询面板 -->
        <!-- <div class="search-dv" v-if="searchFormVisible">
          <SearchForm ref="SearchForm"></SearchForm>
        </div> -->

        <!-- 按钮组 -->
        <div class="toolbar-dv">
          <toolBarBtn
            @changeSearchFormShow="changeSearchFormShow"
            :buttonVisible="buttonVisible"
            :moreButtonList="moreButtonList"
            :parentData="this"
            ref="toolBarBtn"
          ></toolBarBtn>
        </div>

        <!-- 权限分配表格 -->
        <div class="approve-table-dv">
          <!-- 角色 -->
          <div class="left-role-dv" :style="{ height: this.approveCardHeight }">
            <div class="role-list-dv" :style="{ height: this.tableHeight }">
              <navList
                :listData="yearList"
                title="年份"
                :listKey="'nian'"
                indexKey="id"
                :indexValue="indexValue"
                @itemClick="changeDate"
              ></navList>
            </div>
          </div>
          <!-- 菜单明细 -->
          <div class="menu-dv" :style="{ height: this.approveCardHeight }">
            <div class="table-dv">
              <vxe-grid
                ref="xTable"
                resizable
                :column-config="{ minWidth: '80px' }"
                :data="detailList"
                size="mini"
                :mouse-config="{ area: true }"
                highlight-hover-row
                highlight-current-row
                :height="tableHeight"
                :columns="tableColumn"
              >
              </vxe-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddOrSeeHolidayModal
      :parentData="this"
      :updateForm="form"
      :modalType.sync="modalType"
      @updateModalType="updateModalType"
      ref="AddOrSeeHolidayModal"
    />
  </div>
</template>

<script>
import AddOrSeeHolidayModal from './AddOrSeeHolidayModal'
// import NavList from './navList'
export default {
  name: 'YKHoliday',
  components: {
    AddOrSeeHolidayModal
    // NavList
  },
  data() {
    return {
      id: 0,
      searchFormVisible: false,
      tableColumn: [
      ],
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // 按钮组的可见性
      buttonVisible: {
        add: true, // 新增按钮是否显示
        update: false, // 修改按钮
        save: false, // 保存按钮是否显示
        delete: false, // 删除按钮是否显示
        refresh: false, // 刷新数据按钮是否显示
        lock: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // 年份数据列表
      yearList: [
      ],
      form: {
      },
      detailList: [],
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 模态窗类型
      modalType: '',
      moreButtonList: [
        {
          name: '编辑',
          icon: 'el-icon-edit-outline',
          disabled: true,
          event: 'update'
        },
        {
          name: '删除',
          icon: 'el-icon-delete',
          disabled: true,
          event: 'delete'
        },
        {
          name: '锁定',
          icon: 'el-icon-lock',
          disabled: true,
          event: 'lock'
        },
        {
          name: '解锁',
          icon: 'el-icon-unlock',
          disabled: true,
          event: 'unlock'
        },
        {
          name: '刷新数据',
          icon: 'el-icon-refresh',
          disabled: true,
          event: 'refresh'
        }
      ],
      // 选中的tab
      indexValue: ''
    }
  },
  mounted() {
    this.list('one')
  },
  created() {
    this.InitColumn()
  },
  methods: {
    // 初始化
    InitColumn() {
      this.tableColumn = [
        { type: 'seq', width: 40 },
        { title: '节假日', field: 'holidayName' },
        {
          title: '日期', field: 'holidayDate',
          formatter: ['formatDate', 'yyyy-MM-dd']
        },
        { title: '类型', field: 'type' },
        { title: '备注', field: 'memo' }
      ]
    },
    // 初始化权限
    InitRight(form) {
      this.moreButtonList = [
        {
          name: '编辑',
          icon: 'el-icon-edit-outline',
          disabled: !form.id || !this.Authority.edit || form.lockerID > 0,
          event: 'update'
        },
        {
          name: '删除',
          icon: 'el-icon-delete',
          disabled: !form.id || !this.Authority.edit || form.lockerID > 0,
          event: 'delete'
        },
        {
          name: '锁定',
          icon: 'el-icon-lock',
          disabled: !form.id || !this.Authority.edit || form.lockerID > 0,
          event: 'lock'
        },
        {
          name: '解锁',
          icon: 'el-icon-unlock',
          disabled: !form.id || !this.Authority.edit || form.lockerID <= 0,
          event: 'unlock'
        },
        {
          name: '刷新数据',
          icon: 'el-icon-refresh',
          disabled: !this.Authority.see,
          event: 'refresh'
        }
      ]
    },
    // 切换查询面板可见性
    changeSearchFormShow() {
      this.searchFormVisible = !this.searchFormVisible
    },
    changeDate(item) {
      this.form = item
      this.indexValue = String(item.id)
      this.getBoth(item.id)
    },
    // 新增
    add() {
      if (!this.Authority.edit) {
        this.$message.error('您没有相关权限！')
        return
      }
      this.modalType = '新增'
      this.$refs.AddOrSeeHolidayModal.formVisible = true
    },
    // 修改按钮
    update() {
      if (!this.Authority.edit) {
        this.$message.error('您没有相关权限！')
        return
      }
      if (this.form.writerID !== this.$store.state.userInfo.userId) {
        this.$message.error('不可修改他人单据!')
        return
      }
      if (!(this.id) || this.id === 0) {
        this.$message.error('您暂未选中单据，请选择后重试')
        return
      }
      this.modalType = '修改'
      this.form = {
        ...this.form,
        detailList: this.detailList,
      }
      this.$refs.AddOrSeeHolidayModal.formVisible = true
    },
    // 删除数据
    delete() {
      const that = this
      if (!(this.id) || this.id === 0) {
        this.$message.error('您暂未选中单据，请选择后重试')
        return
      }
      if (this.form.writerID !== this.$store.state.userInfo.userId) {
        this.$message.error('不可删除他人单据!')
        return
      }
      this.$confirm('确定要删除本张单据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const { data: res } = await that.$http.delete(
            '/Common/YKHoliday', {
            data: {
              id: that.id,
              effectCondition: that.Authority.alEffectCondition,
              empower: []
            }
          })
          if (!res.isSuccess) {
            that.$message.error(res.errorMessage)
            return false
          }
          that.$message.success('删除成功！')
          that.list('one')
        })
        .catch(() => { })
    },
    // 刷新数据
    refresh() {
      if (!this.Authority.see) {
        this.$message.error('您没有相关权限！')
        return
      }
      this.list()
    },
    // 获取数据
    async list(type = 'list', id = 0) {
      if (!this.Authority.see) {
        this.$message.error('您没有相关权限！')
        return
      }
      const { data: res } = await this.$http.post('/Common/YKHoliday/list',
        {
          pageIndex: 1,
          pageSize: 99999,
          seeType: this.Authority.seeType
        })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.yearList = res.data.rows
      if (this.yearList.length > 0) {
        switch (type) {
          case 'list':
            break
          case 'one':
            this.form = this.yearList[0]
            this.indexValue = String(this.yearList[0]['id'])
            this.getBoth(this.yearList[0]['id'])
            break
          case 'add':
          case 'update':
            this.getBoth(id)
            break
        }
      }
    },
    // 获取明细数据
    async getBoth(id) {
      this.id = id
      const { data: res } = await this.$http.get('/Common/YKHoliday/both',
        {
          params: {
            id: id
          }
        }
      )
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.detailList = res.data.detailList
      this.InitRight(res.data)
    },
    // 修改模态窗类型
    updateModalType(Str) {
      this.modalType = Str
    },
    async lock() {
      const { data: res } = await this.$http.put('/Common/YKHoliday/lock', {
        id: this.form.id,
        effectCondition: this.Authority.alEffectCondition
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('锁定成功！')
      this.getBoth(this.form.id)
    },
    async unlock() {
      const { data: res } = await this.$http.put('/Common/YKHoliday/unlock', {
        id: this.form.id,
        effectCondition: this.Authority.alEffectCondition
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('解锁成功！')
      this.getBoth(this.form.id)
    }
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      let isToolBar = true

      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      return this.tableHeightComputed(tableMargin + this.topBottomMargin, isSearchForm, isToolBar)
    },
    // 表格容器高度，需加上margin边距
    approveCardHeight() {
      return this.tableHeight + this.topBottomMargin
    }
  },
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.search-dv {
  background-color: aquamarine;
  height: 100px;
  margin: @main-margin 10px;
}

.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

.approve-table-dv {
  display: flex;
}
// 角色名称列表
.left-role-dv {
  width: 15%;
  padding: 10px;
}
.role-list-dv {
  width: 100%;
  border-radius: 5px;
  box-shadow: #e2e2e2 0px 0px 3px;
  border: 1px solid #eeeeee;
  overflow: hidden;
  position: relative;
}

// 权限菜单列表
.menu-dv {
  width: 85%;
}

.vxe-checkbox {
  width: 15px !important;
}
</style>
